import React from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthenticatedMutation } from "components/Auth/AuthenticatedQueryProvider";
import { Environment, Project } from "types/api";
import { useAdminRole, useUserRole } from "hooks/useRoleCheck";
import style from "../style.module.css";

interface ActionsProps {
  env: Environment;
  project: Project;
  providerClick: () => void;
}

const Actions: React.FC<ActionsProps> = ({ env, project, providerClick }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { id, privileged } = env;
  const isAdmin = useAdminRole();
  const isUser = useUserRole();

  const archiveEnvironment = useAuthenticatedMutation<void, void>(
    `environments/${id}/archive`,
    {
      requiresTenant: true,
      method: "POST",
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [`projects/${project.id}`],
        });
      },
    }
  );

  return (
    <div className={style.actions} data-cy="environment-actions">
      {env.id && isAdmin && (
        <i
          className="material-icons"
          onClick={providerClick}
          data-tip="Edit Deployment Configuration"
        >
          code
        </i>
      )}

      {(privileged ? isAdmin : isUser) && (
        <i
          className="material-icons"
          onClick={() => navigate(`../../environments/${id}/edit`)}
          data-tip="Edit environment"
        >
          edit
        </i>
      )}

      {isAdmin && (
        <i
          className={`material-icons ${style.archiveButton}`}
          onClick={() => archiveEnvironment.mutate()}
          data-tip="Archive environment"
          style={{
            cursor: archiveEnvironment.isPending ? "wait" : "pointer",
          }}
        >
          archive
        </i>
      )}
    </div>
  );
};

export default Actions;
